<template>
  <div class='warehouse'>
    <div class='nav'>
      <el-form :model='form' label-width='100px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='公司名称:'>
          <el-input v-model='form.companyName' size='mini'
                    placeholder='请输入公司名称'></el-input>
        </el-form-item>
        <el-form-item label='车架号:'>
          <el-input v-model='form.frameNumber' size='mini' placeholder='请输入车架号'></el-input>
        </el-form-item>
        <el-form-item label='开票状态:'>
          <el-select v-model='form.status' size='mini' filterable placeholder='全部'>
            <el-option label='全部' value=''></el-option>
            <el-option label='未开票' value='0'></el-option>
            <el-option label='已开票' value='1'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addInvoicing'>补开票</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          ref='multipleTable'
          @select='handleCurrentChange'
          @select-all='handleCurrentAllChange'
          :reserve-selection='true'
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
          :row-key='(row)=>{ return row.id}'
        >
          <el-table-column type='selection' align='center' width='50px'
                           :selectable='(row)=>{return row.status !== 1}' />
          <el-table-column label='序号' align='center' width='50px' type='index'
                           :index='tableIndexMethod'>

          </el-table-column>
          <el-table-column label='类型' align='center' width='100'>
            <template slot-scope='scope'>
              {{ getTypeStr(scope.row.type) }}
            </template>
          </el-table-column>
          <el-table-column prop='title' label='标题' align='center' width='160' />
          <el-table-column prop='companyName' label='公司名称' align='center' width='220' />
          <el-table-column prop='batchNumber' label='批次号' align='center' width='160' />
          <el-table-column prop='waybillNo' label='运单号' align='center' width='100' />
          <el-table-column prop='frameNumber' label='车架号' align='center' width='160' />
          <el-table-column label='运输方式/作业类型' align='center'>
            <template slot-scope='scope'>
              {{ getTransTypeStr(scope.row.type, scope.row.transType) }}
            </template>
          </el-table-column>
          <el-table-column prop='contactTaxRate' label='合同价税率(%)' align='center' />
          <el-table-column prop='prepareTaxRate' label='预结算税率(%)' align='center' />
          <el-table-column prop='contactTaxPrice' label='含税合同价' align='center' />
          <!--          <el-table-column prop='contactNotaxPrice' label='不含税合同价' align='center'/>-->
          <el-table-column prop='prepareTaxPrice' label='含税预结算价' align='center' />
          <!--          <el-table-column prop='preareNotaxPrice' label='不含税预结算价' align='center'/>-->
          <!--          <el-table-column label='差价类型' align='center'>-->
          <!--            <template slot-scope='scope'>-->
          <!--              {{ scope.row.priceType ? '大于' : '小于' }}-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop='taxPriceDifference' label='含税差价' align='center' />
          <!--          <el-table-column prop='notaxPriceDifference' label='不含税差价' align='center'/>-->
          <el-table-column prop='deductTime' label='使用合同差价时间' align='center' width='200' />
          <el-table-column prop='status' label='开票状态' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.status ? '已开票' : '未开票' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer' style='margin-top: 20px'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>
    <el-dialog title='详情' :visible.sync='DialogVisible'
               :width="activeName==='settlement' ? '1300px' :'700px'" center>
      <div class='detail'>
        <el-tabs v-model='activeName' @tab-click='handleClick'>
          <el-tab-pane label='基础信息' name='Basics'>
            <div style='padding: 0 23px'>
              <el-form :model='detailData' label-position='left'>
                <el-row>
                  <el-col :span='12'>
                    <el-form-item label='对账单编号:'>
                      <span>{{ detailData.supplierName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item label='状态:'>
                      <span>{{ detailData.supplierName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label='标题:'>
                  <span>{{ detailData.supplierName }}</span>
                </el-form-item>
                <el-form-item label='收付类型:'>
                  <span>{{ detailData.supplierName }}</span>
                </el-form-item>
                <el-form-item label='委托商:'>
                  <span>{{ detailData.supplierName }}</span>
                </el-form-item>
                <el-row>
                  <el-col :span='12'>
                    <el-form-item label='含税合同价:'>
                      <span>{{ detailData.supplierName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item label='不含税合同价:'>
                      <span>{{ detailData.supplierName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span='12'>
                    <el-form-item label='含税预结算价:'>
                      <span>{{ detailData.supplierName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item label='不含税预结算价:'>
                      <span>{{ detailData.supplierName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span='12'>
                    <el-form-item label='差价:'>
                      <span>{{ detailData.supplierName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item label='剩余未抵扣差价:'>
                      <span>{{ detailData.supplierName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label='生成对账单时间:'>
                  <span>{{ detailData.supplierName }}</span>
                </el-form-item>

              </el-form>
              <div class='operation'>
                <div class='operationTitle'>
                  <div class='line' />
                  <span>抵扣对账单</span>
                </div>
                <div class='operationTable'>
                  <el-table :data='operationData' border>
                    <el-table-column label='序号' align='center' width='50px' />
                    <el-table-column label='对账单编号' align='center' width='160px' />
                    <el-table-column prop='operateType' label='抵扣金额' align='center' />
                    <el-table-column prop='operationName' label='抵扣时间' align='center' />
                    <el-table-column prop='remark' label='状态' align='center' />
                    <el-table-column prop='remark' label='操作人' align='center' />
                    <el-table-column prop='remark' label='操作时间' align='center' />
                  </el-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label='结算信息' name='settlement'>
            <div class='settleInformation'>
              <el-table
                :data='checkTableData'
                style='width: 100%'
                border
                :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
              >
                <el-table-column prop='Waybill' label='运单编号' align='center' />
                <el-table-column prop='Waybill' label='批次号' align='center' />
                <el-table-column prop='Waybill' label='底盘号' align='center' />
                <el-table-column prop='Waybill' label='品牌' align='center' />
                <el-table-column prop='Waybill' label='型号' align='center' />
                <el-table-column prop='Waybill' label='委托商' align='center' />
                <el-table-column prop='Waybill' label='经销商' align='center' />
                <el-table-column prop='Waybill' label='计划日期' align='center' />
                <el-table-column prop='Waybill' label='发运日期' align='center' />
                <el-table-column prop='Waybill' label='交车日期' align='center' />
                <el-table-column prop='Waybill' label='起运地' align='center' />
                <el-table-column prop='Waybill' label='交车地' align='center' />
                <el-table-column prop='Waybill' label='税率(%)' align='center' />
                <el-table-column prop='Contract' label='含税合同价' align='center' />
                <el-table-column prop='sumNotIncluded' label='不含税合同价' align='center' />
                <el-table-column prop='Waybill' label='预结算方式' align='center' />
                <el-table-column prop='sumBudget' label='含税预结算价' align='center' />
                <el-table-column prop='sumNotBudget' label='不含税预结算价' align='center' />
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>


    <!-- 提交审核 -->
    <el-dialog title='补开票' :visible.sync='invoicingVisible' width='1050px'
               @close='invoicingClose'
               center
               :close-on-click-modal='false'>
      <div class='depart' v-loading='invoicingLoading'>
        <el-form :model='invoicingData' label-width='120px' :rules='invoicingRules' ref='ruleForm2'
                 size='medium'>
          <div-border label='开票选择' divStyle='margin-top: 10px;padding-top:15px;'>
            <el-row>
              <el-col :span='12'>
                <el-form-item label='购买方名称：' label-width='150px' style='margin-bottom: 0'>
                  {{ invoicingData.purchaserName || '无' }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='销售方名称：' label-width='150px' style='margin-bottom: 0'>
                  {{ invoicingData.sellerName || '无' }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='购买纳税人识别号：' label-width='150px' style='margin-bottom: 0'>
                  {{ invoicingData.purchaserDentificaNumber || '无' }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='销售纳税人识别号：' label-width='150px' style='margin-bottom: 0'>
                  {{ invoicingData.sellerDentificaNumber || '无' }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='购买方地址：' label-width='150px' style='margin-bottom: 0'>
                  {{ invoicingData.purchaserAddress || '无' }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='销售方地址：' label-width='150px' style='margin-bottom: 0'>
                  {{ invoicingData.sellerAddress || '无' }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='购买方电话：' label-width='150px' style='margin-bottom: 0'>
                  {{ invoicingData.purchaserTel || '无' }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='销售方电话：' label-width='150px' style='margin-bottom: 0'>
                  {{ invoicingData.sellerTel || '无' }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='购买方开户行：' label-width='150px' style='margin-bottom: 0'>
                  {{ invoicingData.purchaserBankDeposit || '无' }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='销售方开户行：' label-width='150px' style='margin-bottom: 0'>
                  {{ invoicingData.sellerBankDeposit || '无' }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='购买方银行账号：' label-width='150px' style='margin-bottom: 0'>
                  {{ invoicingData.purchaserBankAccount || '无' }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='销售方银行账号：' label-width='150px' style='margin-bottom: 0'>
                  {{ invoicingData.sellerBankAccount || '无' }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label='是否开具销售清单：' label-width='150px' prop='type'>
              <el-radio v-model='isSalesList' :label='0'>否</el-radio>
              <el-radio v-model='isSalesList' :label='1'>是</el-radio>
            </el-form-item>

            <div>
              <el-row type='flex' justify='space-between' align='middle'
                      style='margin-bottom: 10px;'>
                <el-col :span='12'>
                  <el-form-item label='服务名称：' prop='serviceName' label-width='150px'>
                    <el-select v-model='invoicingData.serviceName' placeholder='请选择'>
                      <el-option
                        v-for='(item, index) in serviceNameOptions'
                        :key='index'
                        :label='item.classaName'
                        :value='item.classaName' />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span='12'>
                  <div style='float: right'>
                    开票含税合计金额：{{ invoicingData.taxPrice || 0 }}元
                    开票不含税合计金额：{{ invoicingData.price || 0 }}元
                  </div>
                </el-col>
              </el-row>
            </div>
          </div-border>
          <div class='btnContainer'>
            <el-button size='medium' class='searchBtn' @click='invoicingConfirmClick'>
              确定
            </el-button>
            <el-button size='medium' class='resetBtn' @click='invoicingClose'>关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>


  </div>
</template>

<script>
  import popup from '@/components/popup';
  import selectMap from '@/components/map';
  import divBorder from '@/components/divBorder.vue';
  import {
    getAccountPageList,
  } from '@/service/basicfile';
  import {
    formatTime,
  } from '@/config/mUtils';
  import {
    addInvoicing,
    getInvoicingList,
    getServiceName,
  } from '@/service/getData';

  export default {
    components: {
      popup,
      selectMap,
      divBorder,
    },
    data() {
      return {
        form: {
          companyName: '',
          title: '',
          status: '',
          page: 1,
          rows: 10,
        },
        total: 0,
        tableLoad: false,
        TableDatas: [
          // {warehouseName:'对账单编号'}
        ],
        detailData: {},
        activeName: 'Basics',
        DialogVisible: false,
        checkTableData: [],
        operationData: [],
        rules: {
          warehouseName: {
            required: true,
            message: '请输入委托商仓库名称',
            trigger: 'blur',
          },
          customer: {
            required: true,
            message: '请选择委托商',
            trigger: 'blur',
          },
          address: {
            required: true,
            message: '请输入地址',
            trigger: 'blur',
          },
        },
        invoicingVisible: false,
        isSalesList: 0,
        // 服务名称数据
        serviceNameOptions: [],
        invoicingLoading: false,
        invoicingData: {},
        invoicingRules: {
          isSalesList: [
            {
              required: true,
              message: '请选择是否开具销售清单',
              trigger: 'change',
            },
          ],
          serviceName: [
            {
              required: true,
              message: '请选择服务类型',
              trigger: 'change',
            },
          ],
        },
        selectedStatus: false,
        checkData: [],
      };
    },
    filters: {
      createTimeFormat: function(value) {
        console.log(value);
        if (value) {
          return formatTime(value, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }

      },
    },
    mounted() {
      this.getAccountPageList();
      this.getServiceName();
    },
    methods: {
      async getAccountPageList() {
        this.tableLoad = true;
        let res = await getAccountPageList(this.form);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;

      },
      compareDate(d1, d2) {
        return ((new Date(d1.replace(/-/g, '\/'))) > (new Date(d2.replace(/-/g, '\/'))));
      },
      // 结束时间
      dateChange(val) {
        if (this.form.createTimes[1] && this.form.createTimes[0] && this.compareDate(this.form.createTimes[0], this.form.createTimes[1])) {
          if (val == this.form.createTimes[1]) this.form.createTimes[1] = '';
          if (val == this.form.createTimes[0]) this.form.createTimes[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      searchBtn() {
        this.getAccountPageList();
        this.form.page = 1;
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.createTimes = ['', ''];
        this.form.page = 1;
        this.form.rows = 10;

      },
      tableIndexMethod(index) {
        return this.form.rows * (this.form.page - 1) + index + 1;
      },
      contractSizeChange(row) {
        this.form.rows = row;

      },
      contractCurrentChange(page) {
        this.form.page = page;

      },
      handleClick() {

      },
      async getInvoicingList() {
        const params = {
          id: this.checkData[0].accountId,
          settlementPriceDifferenceList: [],
        };
        this.checkData.forEach(res => {
          params.settlementPriceDifferenceList.push({
            id: res.id,
            taxPriceDifference: res.taxPriceDifference,
          });
        });
        this.invoicingLoading = true;
        const {
          data,
          message,
          status,
        } = await getInvoicingList(params);
        this.invoicingLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.invoicingData = data;
      },
      //详情
      detailsClick() {
        this.DialogVisible = true;
      },
      invoicingConfirmClick() {
        this.invoicingData.isSalesList = this.isSalesList;
        const params = {
          id: this.checkData[0].accountId,
          settlementPriceDifferenceList: [],
          invoiceManageList: [this.invoicingData],
        };
        this.checkData.forEach(res => {
          params.settlementPriceDifferenceList.push({
            id: res.id,
          });
        });
        this.$refs.ruleForm2.validate(async (valid) => {
          if (valid) {
            const {
              status,
              message,
            } = await addInvoicing(params);
            if (status === 0) {
              this.$message.success(message);
              this.invoicingVisible = false;
              this.$refs.ruleForm2.resetFields();
              await this.getAccountPageList();
              this.$refs.multipleTable.clearSelection();
              this.invoicingData = {};
            } else {
              this.$message.warning(message);
            }
          } else {
            return false;
          }
        });
      },
      addInvoicing() {
        if (this.checkData.length === 0) return this.$message.warning('请选择数据后补开票！');
        this.invoicingVisible = true;
        this.getInvoicingList();
      },
      invoicingClose() {
        this.invoicingVisible = false;
        this.$refs.ruleForm2.resetFields();
        this.invoicingData = {};
      },
      async getServiceName() {
        const {
          data,
          message,
          status,
        } = await getServiceName();
        if (status !== 0) return this.$message.warning(message);
        this.serviceNameOptions = data;
      },

      // 多选事件触发
      handleCurrentChange(val) {
        this.checkData = val;

        let companyName = '';
        let title = '';
        const array = val.filter((item, index) => {
          if (index === 0) {
            companyName = item.companyName;
            title = item.title;
          }
          return companyName !== item.companyName || title !== item.title;
        });
        console.log(array);
        // 筛选  供应商相同数据
        this.checkData = val.filter(item => (companyName === item.companyName && title === item.title));
        let tipOne = true;
        array.forEach((value) => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选
          if (tipOne) {
            this.$message.warning('只能选择相同公司名称且标题相同数据！');
            tipOne = false;
          }
          this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => value.id === item.id), false);
        });
        // this.$refs.accountState.calculation()
      },
      handleCurrentAllChange(val) {
        this.selectedStatus = !this.selectedStatus;

        if (this.selectedStatus) {
          this.checkData = val;

          let companyName = '';
          let title = '';
          const array = val.filter((item, index) => {
            if (index === 0) {
              companyName = item.companyName;
              title = item.title;
            }
            return companyName !== item.companyName || title !== item.title;
          });
          console.log(array);
          // 筛选  供应商相同数据
          this.checkData = val.filter(item => (companyName === item.companyName && title === item.title));
          let tipOne = true;
          array.forEach((value) => {
            // 只有使用表格原数据，才会生效   从表格原数据中赛选
            if (tipOne) {
              this.$message.warning('只能选择相同公司名称且标题相同数据！');
              tipOne = false;
            }
            this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => value.id === item.id), false);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
        // this.$refs.accountState.calculation()
      },
      getTypeStr(val) {
        switch (val) {
          case 1:
            return '委托商运费';
          case 2:
            return '委托商港口费';
          case 4:
            return '供应商公路运费';
          case 5:
            return '供应商水路运费';
          case 6:
            return '供应商港口操作费';
          case 8:
            return '供应商港口堆存费';
          case 9:
            return '供应商提车费';
        }
      },
      getTransTypeStr(type, val) {
        if (type === 1) {
          switch (val) {
            case 1:
              return '公路';
            case 2:
              return '水路';
          }
        } else if (type === 2) {
          switch (val) {
            case 1:
              return '装船';
            case 2:
              return '卸船';
          }
        } else if (type === 4 || type === 5 || type === 9) {
          switch (val) {
            case 0:
              return '公路';
            case 1:
              return '水路';
          }
        } else if (type === 6) {
          switch (val) {
            case 1:
              return '装车';
            case 2:
              return '卸车';
            case 3:
              return '过驳';
            case 4:
              return '转船';
          }
        }
      },
      getShipping(val) {
        switch (val) {
          case 2:
            return '水路';
          case 1:
            return '公路';
          default:
            return '--';
        }
      },
    },
  };
</script>


<style lang='scss' scoped>
  .warehouse {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .content {

    }

    ::v-deep .detail {


      width: 100%;
      padding: 10px 0 20px 20px;

      .el-form-item {
        margin-bottom: 5px;
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }

      .settleInformation {
        .el-table th.is-leaf {
          border-bottom: 1px solid #EBEEF5;
          padding: 0;
        }
      }

    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 25px;
      margin-top: 35px;

      button {
        margin: 0 15px;
      }
    }

  }

  ::v-deep {

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      color: #606266;
    }
  }

  .depart {
    width: 100%;
    padding: 10px 40px 10px 10px;
    max-height: 75vh;
    overflow: auto;

    .imgUp {
      display: flex;
      flex-direction: column;

      .imgLength {
        display: flex;
        align-items: center;
        width: 90%;

        span {
          margin-left: auto;
          color: rgb(183, 183, 183);
          font-size: 16px;
        }
      }
    }

    &Table {
      margin-bottom: 25px;
      width: 100%;

      .tableAddBtnContainer {
        border: 1px solid #EBEEF5;;
        border-top-style: none;
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 15px;

        .AddContainer {
          display: flex;
          align-items: center;

          &:hover {
            cursor: pointer;
          }
        }

        img {
          object-fit: cover;
          margin-right: 5px;
        }

        p {
          font-size: 13px;
          color: #F59A23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }
      }

      ::v-deep {
        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .specialItem {
      ::v-deep {
        .el-form-item__content {
          margin-left: 0 !important;
        }
      }
    }

    ::v-deep {
      .el-form-item__label {
        font-weight: 700;
      }

      .el-form-item {
        margin-bottom: 13px;
      }

      .el-form-item__label {
        padding: 0;
      }

      .el-form-item__content {
        position: relative;
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;

      button {
        margin: 0 15px;
      }
    }
  }
</style>
